import { ChangeDetectionStrategy, Component, computed } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { EntityWithUuid, NkCardListItemAbstractComponent } from '@nk/ui-lib';

@Component({
  selector: 'nk-card-list-item-yes-no',
  imports: [TranslateModule],
  templateUrl: './card-list-item-yes-no.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardListItemYesNoComponent<Entity extends EntityWithUuid> extends NkCardListItemAbstractComponent<Entity> {
  public value = computed(() => {
    const value = this.valueSignal();
    if (!value) {
      return null;
    }
    return value.entity[value.prop];
  });
}
